const SHOW_VISIBLE_ROWS = false

export function makeRowPinnedTop (context, gridApi) {
  console.log('makeRowPinnedTop', context)

  listOfVisibleRows(gridApi)

  const pinnedRows = []

  if (context.gridMethod === 'byAllAccounts') {
    pinnedRows.push({
      id: 'total',
      name: 'Total (should be 0 for statement total)'
    })
  }

  return pinnedRows
}

export function listOfVisibleRows (gridApi) {
  if (!SHOW_VISIBLE_ROWS) return []

  const visibleRows = []

  gridApi?.forEachNodeAfterFilterAndSort(function (rowNode) {
    // console.log('rowNode', rowNode)
    visibleRows.push(rowNode.data)
  })

  console.log('visibleRows', visibleRows)
  return visibleRows
}
